import { useCallback } from 'react';

import {
  FetchLifestylesCacheKey,
  FetchLifestylesSort,
  FetchLifestylesSortTypes
} from '../../lifestylesTypes';

import { useLifestylesFiltersCache } from '../useLifestylesFiltersCache';

interface LifestylesSortDropdownOptions {
  lifestylesBaseCacheKey: FetchLifestylesCacheKey;
  sortLifestyles: (nextSort: FetchLifestylesSort) => void;
}

function useLifestylesSortDropdown({
  lifestylesBaseCacheKey,
  sortLifestyles
}: LifestylesSortDropdownOptions) {
  const { setCachedLifestylesSort } = useLifestylesFiltersCache({
    cacheKey: lifestylesBaseCacheKey
  });

  const handleSortByMostLiked = useCallback<() => void>(() => {
    setCachedLifestylesSort([
      FetchLifestylesSortTypes.USERS_CHOSEN_LIFESTYLES_COUNT_DESC
    ]);
    sortLifestyles([
      FetchLifestylesSortTypes.USERS_CHOSEN_LIFESTYLES_COUNT_DESC
    ]);
  }, [sortLifestyles, setCachedLifestylesSort]);

  const handleSortByMostUsed = useCallback<() => void>(() => {
    setCachedLifestylesSort([
      FetchLifestylesSortTypes.SELECTED_LIFESTYLES_COUNT_DESC
    ]);
    sortLifestyles([FetchLifestylesSortTypes.SELECTED_LIFESTYLES_COUNT_DESC]);
  }, [sortLifestyles, setCachedLifestylesSort]);

  const handleSortByNewest = useCallback<() => void>(() => {
    setCachedLifestylesSort([FetchLifestylesSortTypes.CREATED_AT_DESC]);
    sortLifestyles([FetchLifestylesSortTypes.CREATED_AT_DESC]);
  }, [sortLifestyles, setCachedLifestylesSort]);

  return {
    handleSortByMostLiked,
    handleSortByMostUsed,
    handleSortByNewest
  };
}

export default useLifestylesSortDropdown;
